import { useState } from "react";
import {
  Card,
  Box,
  Text,
  Badge,
  Button,
  Grid,
  Avatar,
  CardSection,
  Group,
} from "@mantine/core";
import UpdateProfileModal from "./UpdateProfileModal";

export default function Profile() {
  const user = JSON.parse(localStorage.getItem("userInfo"));

  const [editProfile, setEditProfile] = useState(false);
  return (
    <>
      <Box
        sx={{
          width: "100%",
          maxWidth: "1000px",
          margin: "auto",
        }}
      >
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid.Col lg={6} xs={12}>
            <Card
              shadow="md"
              p="lg"
              radius="md"
              sx={{ borderColor: "#fbbe32" }}
              withBorder
            >
              <Card.Section
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  padding: "15px",
                }}
              >
                <Avatar
                  variant="outline"
                  radius="lg"
                  size="250px"
                  color="yellow"
                  src={`https://api.ticketin.net/user/${user?.profile_image}`}
                />

                <Badge
                  sx={{ marginTop: "10px" }}
                  color="yellow"
                  size="lg"
                  variant="filled"
                >
                  {user?.privileges}
                </Badge>
              </Card.Section>
              <CardSection
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <Box>
                  <Group>
                    <Text size="md" weight={400}>
                      User Name:
                    </Text>
                    <Text size="md" weight={700}>
                      {user?.username}
                    </Text>
                  </Group>
                  <Group>
                    <Text size="md" weight={400}>
                      Email:
                    </Text>
                    <Text size="md" weight={700}>
                      {user?.email}
                    </Text>
                  </Group>
                </Box>
              </CardSection>

              <CardSection
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  padding: "15px",
                }}
              >
                <Button
                  onClick={() => {
                    setEditProfile(true);
                  }}
                  variant="filled"
                  color="yellow"
                  mt="md"
                  radius="md"
                >
                  Edit Profile
                </Button>
              </CardSection>
            </Card>
          </Grid.Col>
        </Grid>
        <UpdateProfileModal
          setEditProfile={setEditProfile}
          opened={editProfile}
          user={user}
        />
      </Box>
    </>
  );
}
